export var ModelYearSubPageName;
(function (ModelYearSubPageName) {
    ModelYearSubPageName["TRIMS"] = "trims";
    ModelYearSubPageName["ACCESSORIES"] = "accessories";
    ModelYearSubPageName["SPECIFICATIONS"] = "specifications";
})(ModelYearSubPageName || (ModelYearSubPageName = {}));
